import React from 'react';
import './Solutions.css';

const Solutions = () => {
  const handleDiscussProject = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="solutions" id="solutions">
      <div className="container">
        <h2 className="section-title">Our Solutions</h2>
        <p className="section-subtitle">
          Innovative products engineered to solve complex business challenges
        </p>
        
        <div className="solutions-wrapper">
          <div className="solution-featured">
            <div className="solution-visual">
              <div className="visual-element el-1"></div>
              <div className="visual-element el-2"></div>
              <div className="visual-element el-3"></div>
              <div className="dashboard-mockup">
                <div className="mockup-header">
                  <div className="mockup-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                <div className="mockup-content">
                  <div className="chart-bar" style={{height: '60%'}}></div>
                  <div className="chart-bar" style={{height: '80%'}}></div>
                  <div className="chart-bar" style={{height: '45%'}}></div>
                  <div className="chart-bar" style={{height: '90%'}}></div>
                </div>
              </div>
            </div>
            
            <div className="solution-content">
              <div className="solution-badge">
                <span className="badge-star">⭐</span>
                <span>Featured Solution</span>
              </div>
              
              <h3 className="solution-name">Biwalls</h3>
              <p className="solution-tagline">Business Intelligence at Your Fingertips</p>
              
              <p className="solution-description">
                Advanced business intelligence platform that transforms raw data into actionable insights. 
                Visualize complex data patterns, track KPIs in real-time, and make informed decisions 
                with our powerful analytics engine.
              </p>
              
              <div className="solution-features-grid">
                <div className="feature-item">
                  <div className="feature-icon">📊</div>
                  <div>
                    <h4>Real-time Dashboards</h4>
                    <p>Live data visualization and monitoring</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">📈</div>
                  <div>
                    <h4>Advanced Analytics</h4>
                    <p>Deep insights with AI-powered analysis</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">🔄</div>
                  <div>
                    <h4>Seamless Integration</h4>
                    <p>Connect with your existing data</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">📱</div>
                  <div>
                    <h4>Mobile Access</h4>
                    <p>Access insights anywhere, anytime</p>
                  </div>
                </div>
              </div>
              
              <div className="solution-actions">
                <button className="btn-primary" onClick={handleDiscussProject}>
                  Explore Biwalls <span className="arrow">→</span>
                </button>
                <button className="btn-secondary" onClick={handleDiscussProject}>
                  <span>Request Demo</span>
                </button>
              </div>
            </div>
          </div>

          <div className="custom-solutions-card">
            <div className="custom-solutions-content">
              <h3>Need Something Custom?</h3>
              <p>
                We specialize in developing tailored solutions that perfectly fit your unique 
                business requirements. From concept to deployment, our expert team guides you 
                through every step of the development journey.
              </p>
              
              <div className="custom-benefits">
                <div className="benefit-tag">🎯 Requirement Analysis</div>
                <div className="benefit-tag">⚙️ Custom Development</div>
                <div className="benefit-tag">🚀 Deployment & Training</div>
                <div className="benefit-tag">📈 Ongoing Support</div>
              </div>
              
              <button className="btn-outline" onClick={handleDiscussProject}>
                Discuss Your Project <span className="arrow">→</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solutions;
